import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../components/AlertContext";
import { PlatformContext } from "../components/Platform/PlatformContext";

const server_url = process.env.REACT_APP_BACKEND_URL;

const RequestNewPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const platform = React.useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${server_url}/resendverification`, {
        email,
      });

      if (response.data.status) {
        // console.log("Check your mailbox:", response.data);
        showAlert("success", "Check your mailbox");
        setEmail("");
      } else {
        // console.log("Error requesting reset mail:", response.data.error);
        showAlert("error", "Request failed");
      }
    } catch (error: any) {
      // console.log("Password reset request failed", error);
      showAlert("error", "Request failed");
    }
  };

  return (
    <div
      className={
        (isMobile ? "" : "items-center ") +
        "flex justify-center h-screen bg-header-secondary"
      }
    >
      <form
        onSubmit={handleSubmit}
        className={"p-6 bg-white rounded shadow-md w-full max-w-sm"}
      >
        <h2 className="mb-4 text-2xl font-semibold text-center">
          Resend Verification Link
        </h2>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">E-Mail</label>
          <input
            type="email"
            className="w-full px-3 py-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          New Verification
        </button>
      </form>
    </div>
  );
};

export default RequestNewPassword;
